import { render } from "./WrongQuestionsView.vue?vue&type=template&id=f7f31f6a&scoped=true"
import script from "./WrongQuestionsView.vue?vue&type=script&lang=js"
export * from "./WrongQuestionsView.vue?vue&type=script&lang=js"

import "./WrongQuestionsView.vue?vue&type=style&index=0&id=f7f31f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f31f6a"]])

export default __exports__